import { useIsFoundationalPillarsNavPhase1Enabled } from '@ms/yammer-features-app-navigation';
import { useIsTopLevelFeaturePage } from '@ms/yammer-hooks/dist/navigation';
import { useIsVivaEngageRebranding } from '@ms/yammer-hooks/dist/rebranding/useIsVivaEngageRebranding';
import { useTranslations } from '@ms/yammer-i18n-react';
import CommonStrings from '@ms/yammer-strings/dist/Common';
import PanesStrings from '@ms/yammer-strings/dist/Panes';
import {
  rebrandedWebMainAreaHeroBackgroundDarkPath,
  rebrandedWebMainAreaHeroBackgroundPath,
} from '@ms/yammer-web-components/dist/images';
import { AppLayoutWeb, NavPhase1AppLayout } from '@ms/yammer-web-core-ui/dist/components/AppLayout';
import { PageLayoutProps, mapPixelWidthToPageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { useContainerWidth } from '@ms/yammer-web-core-ui/dist/util/responsiveness';
import { useTheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import React, { FC, Suspense } from 'react';

const AppLayout: FC<PageLayoutProps> = (props) => {
  const openAriaLabel = useTranslations(PanesStrings).showAdditionalInformationPane();
  const closeAriaLabel = useTranslations(CommonStrings).commonClose();
  const isFoundationalPillarsNavPhase1Enabled = useIsFoundationalPillarsNavPhase1Enabled();

  const width = useContainerWidth();
  const isVivaEngageRebrand = useIsVivaEngageRebranding();
  const isTopLevelFeaturePage = useIsTopLevelFeaturePage();
  const mappedWidth = mapPixelWidthToPageLayoutWidth(width);
  const { isInverted } = useTheme();
  const { children, onRenderHeader, onRenderSubHeader, onRenderLeftSidebar, onRenderBanner, onRenderFooter } = props;

  const rebrandedHeroBannerImgPath = isInverted
    ? rebrandedWebMainAreaHeroBackgroundDarkPath
    : rebrandedWebMainAreaHeroBackgroundPath;

  const heroBannerImgSrc = isTopLevelFeaturePage && isVivaEngageRebrand ? rebrandedHeroBannerImgPath : undefined;

  const leftSidebar = onRenderLeftSidebar?.();
  const header = onRenderHeader?.(mappedWidth);
  const subheader = onRenderSubHeader?.();
  const banner = onRenderBanner?.(mappedWidth);
  const footer = onRenderFooter?.();

  return isFoundationalPillarsNavPhase1Enabled ? (
    <Suspense fallback={null}>
      <NavPhase1AppLayout
        header={header}
        banner={banner}
        subHeader={subheader}
        bannerImageSrc={heroBannerImgSrc}
        isNewNavRedesign={true}
        leftNav={leftSidebar}
        openContentSidebarAriaLabel={openAriaLabel}
        closeContentSidebarAriaLabel={closeAriaLabel}
        footer={footer}
      >
        {children}
      </NavPhase1AppLayout>
    </Suspense>
  ) : (
    <AppLayoutWeb
      header={header}
      banner={banner}
      subHeader={subheader}
      mainAreaBackgroundSrc={heroBannerImgSrc}
      leftNav={leftSidebar}
      openContentSidebarAriaLabel={openAriaLabel}
      closeContentSidebarAriaLabel={closeAriaLabel}
      footer={footer}
    >
      {children}
    </AppLayoutWeb>
  );
};

export default AppLayout;
